// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChromaFlare__demo___rEDbA {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;
    padding: 8px 4px 4px;
    color: rgba(91, 69, 38, 0.9);
    font-family: "Share Tech Mono", monospace;
}

.ChromaFlare__scene___eHTIT {
    position: relative;
    isolation: isolate;
    width: min(100%, 500px);
    height: 270px;
    overflow: hidden;
    border-radius: 8px;
    background:
        radial-gradient(circle at 50% 46%, rgba(255, 177, 61, 0.24), transparent 31%),
        radial-gradient(ellipse at 13% 57%, rgba(161, 143, 127, 0.18), transparent 38%),
        radial-gradient(ellipse at 89% 41%, rgba(112, 124, 139, 0.16), transparent 39%),
        linear-gradient(135deg, #514f4e 0%, #786c62 47%, #575451 100%);
    box-shadow:
        inset 0 0 42px rgba(255, 206, 136, 0.17),
        inset 0 -24px 36px rgba(24, 22, 25, 0.22),
        0 9px 25px rgba(36, 25, 26, 0.3);
}

.ChromaFlare__scene___eHTIT::before {
    position: absolute;
    z-index: 1;
    inset: 0;
    background:
        radial-gradient(ellipse at 49% 47%, rgba(255, 216, 133, 0.18), transparent 29%),
        radial-gradient(ellipse at 14% 27%, rgba(238, 192, 143, 0.1), transparent 31%),
        radial-gradient(ellipse at 84% 66%, rgba(116, 136, 165, 0.1), transparent 33%);
    content: "";
    mix-blend-mode: screen;
    pointer-events: none;
    animation: ChromaFlare__daylightDrift___vLTjC 11s ease-in-out infinite alternate;
}

.ChromaFlare__ambient___vspU2 {
    position: absolute;
    z-index: 1;
    width: 250px;
    height: 230px;
    border-radius: 50%;
    filter: blur(32px);
    mix-blend-mode: screen;
    opacity: 0.46;
    animation: ChromaFlare__ambientFloat___sEjEH 12s ease-in-out infinite alternate;
}

.ChromaFlare__ambientGold___XicCQ {
    top: 28px;
    left: 2%;
    background: rgba(239, 212, 174, 0.18);
    opacity: 0.44;
}

.ChromaFlare__ambientWhite___Zt6Bk {
    right: -11%;
    bottom: -74px;
    background: rgba(226, 232, 240, 0.24);
    opacity: 0.42;
    animation-delay: -4s;
}

.ChromaFlare__glassPlane___xl89E,
.ChromaFlare__glassFacet___prsEl,
.ChromaFlare__fragment___prISd {
    --glint-delay: -6s;
    --glint-duration: 29s;
    position: absolute;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.52);
    background:
        linear-gradient(135deg, rgba(255, 255, 255, 0.34), rgba(255, 255, 255, 0.035) 42%, rgba(255, 211, 124, 0.12) 78%, rgba(255, 255, 255, 0.22)),
        rgba(255, 255, 255, 0.025);
    box-shadow:
        inset 1px 1px 2px rgba(255, 255, 255, 0.78),
        inset -2px -3px 7px rgba(188, 130, 38, 0.12),
        0 14px 26px rgba(14, 10, 13, 0.13);
    backdrop-filter: blur(2px) saturate(132%) contrast(106%);
}

.ChromaFlare__glassPlane___xl89E {
    border-color: rgba(255, 255, 255, 0.42);
    background:
        linear-gradient(135deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.012) 42%, rgba(235, 242, 255, 0.025) 78%, rgba(255, 255, 255, 0.1)),
        rgba(255, 255, 255, 0.008);
    box-shadow:
        inset 1px 1px 2px rgba(255, 255, 255, 0.62),
        inset -2px -3px 7px rgba(210, 220, 235, 0.035),
        0 14px 26px rgba(14, 10, 13, 0.11);
    backdrop-filter: blur(1.5px) saturate(100%) contrast(102%);
}

.ChromaFlare__glassPlane___xl89E,
.ChromaFlare__glassFacet___prsEl {
    will-change: transform;
}

.ChromaFlare__glassPlane___xl89E::after,
.ChromaFlare__glassFacet___prsEl::after,
.ChromaFlare__fragment___prISd::after {
    position: absolute;
    inset: 0;
    content: "";
    mix-blend-mode: screen;
}

.ChromaFlare__glassPlane___xl89E::after,
.ChromaFlare__glassFacet___prsEl::after {
    background:
        radial-gradient(circle at 31% 38%, rgba(255, 255, 255, 0.24) 0 0.6px, transparent 1.2px),
        radial-gradient(circle at 68% 62%, rgba(255, 236, 190, 0.18) 0 0.7px, transparent 1.3px),
        linear-gradient(73deg, transparent 46%, rgba(255, 255, 255, 0.11) 46.6%, transparent 47.2%),
        linear-gradient(90deg, rgba(255, 179, 56, 0.2), transparent 2.5% 97%, rgba(116, 157, 255, 0.17)),
        linear-gradient(125deg, rgba(255, 255, 255, 0.48), transparent 15% 76%, rgba(232, 172, 68, 0.12));
    opacity: 0.68;
}

.ChromaFlare__glassPlane___xl89E::after {
    background:
        radial-gradient(circle at 31% 38%, rgba(255, 255, 255, 0.2) 0 0.6px, transparent 1.2px),
        radial-gradient(circle at 68% 62%, rgba(244, 248, 255, 0.13) 0 0.7px, transparent 1.3px),
        linear-gradient(73deg, transparent 46%, rgba(255, 255, 255, 0.09) 46.6%, transparent 47.2%),
        linear-gradient(90deg, rgba(255, 255, 255, 0.14), transparent 2.5% 97%, rgba(178, 198, 238, 0.09)),
        linear-gradient(125deg, rgba(255, 255, 255, 0.34), transparent 15% 76%, rgba(235, 240, 250, 0.08));
    opacity: 0.48;
}

.ChromaFlare__fragment___prISd::after {
    inset: -1px;
    background:
        linear-gradient(96deg, rgba(255, 91, 43, 0.72) 0 1px, transparent 2px calc(100% - 3px), rgba(105, 151, 255, 0.66) calc(100% - 2px)),
        linear-gradient(133deg, transparent 34%, rgba(255, 231, 147, 0.1) 42%, rgba(255, 255, 255, 0.94) 49%, rgba(109, 158, 255, 0.48) 52%, transparent 59%);
    filter: blur(0.25px);
    opacity: 0.04;
    animation: ChromaFlare__spectralEdge___OREU_ var(--glint-duration) cubic-bezier(0.42, 0, 0.24, 1) var(--glint-delay) infinite;
}

.ChromaFlare__glassPlane___xl89E::before,
.ChromaFlare__glassFacet___prsEl::before,
.ChromaFlare__fragment___prISd::before {
    position: absolute;
    inset: -18% -24%;
    background: linear-gradient(
        108deg,
        transparent 43%,
        rgba(255, 170, 45, 0.1) 45%,
        rgba(255, 226, 124, 0.62) 47%,
        rgba(255, 255, 230, 0.9) 49%,
        rgba(242, 125, 69, 0.34) 51%,
        transparent 54%
    );
    content: "";
    filter: blur(1.2px);
    mix-blend-mode: screen;
    opacity: 0.1;
    animation: ChromaFlare__internalRefraction___SD8OJ var(--glint-duration) cubic-bezier(0.42, 0, 0.24, 1) var(--glint-delay) infinite;
}

.ChromaFlare__glassPlane___xl89E::before {
    background: linear-gradient(
        108deg,
        transparent 44%,
        rgba(255, 255, 255, 0.05) 46%,
        rgba(255, 253, 245, 0.48) 48.5%,
        rgba(192, 210, 245, 0.1) 50.5%,
        transparent 53%
    );
    opacity: 0.06;
}

.ChromaFlare__planeBack___eu2rz {
    --glint-delay: -18s;
    --glint-duration: 47s;
    z-index: 2;
    top: -28px;
    left: 23%;
    width: 54%;
    height: 185px;
    clip-path: polygon(4% 13%, 50% 0, 97% 14%, 84% 89%, 45% 100%, 0 75%);
    opacity: 0.06;
    filter: blur(2.5px);
    transform: rotate(-5deg);
    animation: ChromaFlare__planeBackFloat____2WJw 64s -17s ease-in-out infinite alternate;
}

.ChromaFlare__planeLeft___jDrdr {
    --glint-delay: -31s;
    --glint-duration: 53s;
    z-index: 3;
    top: 27px;
    left: -27%;
    width: 50%;
    height: 216px;
    clip-path: polygon(0 4%, 63% 0, 100% 25%, 83% 51%, 100% 88%, 44% 100%, 0 79%);
    opacity: 0.16;
    filter: blur(1.4px);
    transform: rotate(-14deg);
    animation: ChromaFlare__planeLeftFloat___GaeFM 52s -8s ease-in-out infinite alternate;
}

.ChromaFlare__planeRight___tlvov {
    --glint-delay: -11s;
    --glint-duration: 59s;
    z-index: 3;
    top: 4px;
    right: -26%;
    width: 34%;
    height: 205px;
    clip-path: polygon(14% 0, 100% 10%, 80% 39%, 100% 73%, 55% 100%, 0 84%, 21% 49%, 0 15%);
    opacity: 0.14;
    filter: blur(1.5px);
    transform: rotate(12deg);
    animation: ChromaFlare__planeRightFloat___uN44O 58s -21s ease-in-out infinite alternate;
}

.ChromaFlare__edgePrism___lOQ3v {
    --glint-delay: -14s;
    --glint-duration: 37s;
    z-index: 3;
    width: 94px;
    height: 148px;
    border-color: rgba(255, 255, 255, 0.26);
    background:
        linear-gradient(137deg, rgba(255, 255, 255, 0.2), transparent 38%, rgba(255, 219, 126, 0.1) 74%, rgba(255, 255, 255, 0.16)),
        rgba(255, 255, 255, 0.012);
    opacity: 0.24;
    filter: blur(0.6px) saturate(122%);
    will-change: transform;
    animation: ChromaFlare__edgePrismFloat___kN_Gd 46s cubic-bezier(0.45, 0, 0.55, 1) -13s infinite alternate;
}

.ChromaFlare__edgePrism___lOQ3v::after {
    background:
        linear-gradient(111deg, transparent 27%, rgba(255, 78, 58, 0.15) 39%, rgba(255, 219, 96, 0.58) 47%, rgba(255, 255, 255, 0.86) 50%, rgba(86, 221, 255, 0.54) 54%, rgba(207, 88, 255, 0.34) 61%, transparent 75%),
        linear-gradient(90deg, rgba(255, 84, 56, 0.18), transparent 13% 84%, rgba(78, 181, 255, 0.2));
    filter: saturate(145%);
    opacity: 0.42;
    animation: ChromaFlare__edgeGlassGlint___Mx825 27s cubic-bezier(0.42, 0, 0.24, 1) -7s infinite;
}

.ChromaFlare__edgePrismLeft___f2v20 {
    --edge-start-x: -5px;
    --edge-end-x: 4px;
    --edge-start-rotation: -9deg;
    --edge-end-rotation: -6deg;
    top: -18px;
    left: -36px;
    clip-path: polygon(28% 0, 100% 24%, 76% 100%, 0 75%);
}

.ChromaFlare__edgePrismRight___ZGp85 {
    --edge-start-x: 5px;
    --edge-end-x: -4px;
    --edge-start-rotation: 8deg;
    --edge-end-rotation: 11deg;
    top: 141px;
    right: -40px;
    clip-path: polygon(0 19%, 72% 0, 100% 76%, 25% 100%);
    animation-delay: -29s;
}

.ChromaFlare__edgeSeam___DU14Z {
    --seam-angle: 0deg;
    position: absolute;
    z-index: 4;
    width: 1px;
    background: linear-gradient(
        180deg,
        transparent 0 12%,
        rgba(255, 109, 72, 0.25) 19% 26%,
        transparent 34% 48%,
        rgba(255, 229, 143, 0.52) 54% 62%,
        rgba(91, 218, 255, 0.43) 63% 70%,
        transparent 78% 100%
    );
    box-shadow: 0 0 7px rgba(255, 217, 126, 0.24), 0 0 13px rgba(99, 204, 255, 0.11);
    filter: blur(0.3px);
    mix-blend-mode: screen;
    opacity: 0.23;
    pointer-events: none;
    animation: ChromaFlare__edgeSeamDrift___O9Onc 34s cubic-bezier(0.45, 0, 0.55, 1) -12s infinite alternate;
}

.ChromaFlare__edgeSeamLeft___Vui7z {
    top: 8%;
    left: 7%;
    height: 73%;
    --seam-angle: -3deg;
}

.ChromaFlare__edgeSeamRight___WYchq {
    top: 42%;
    right: 13%;
    height: 42%;
    opacity: 0.16;
    --seam-angle: 7deg;
    animation-delay: -27s;
}

.ChromaFlare__glassFacet___prsEl {
    z-index: 4;
    width: 68px;
    height: 124px;
    clip-path: polygon(50% 0, 100% 49%, 52% 100%, 0 51%);
    backdrop-filter: none;
}

.ChromaFlare__glassFacet___prsEl::after {
    background:
        linear-gradient(90deg, rgba(255, 70, 49, 0.52), transparent 5% 95%, rgba(80, 153, 255, 0.58)),
        linear-gradient(136deg, transparent 38%, rgba(255, 218, 85, 0.22) 44%, rgba(255, 255, 255, 0.62) 49%, rgba(91, 219, 255, 0.34) 52%, rgba(224, 90, 255, 0.2) 56%, transparent 63%);
    filter: saturate(145%);
    opacity: 0.62;
    animation: ChromaFlare__facetChroma___cK3tD 23s cubic-bezier(0.42, 0, 0.24, 1) var(--glint-delay) infinite;
}

.ChromaFlare__facetOne___Ww8G3 {
    --glint-delay: -24s;
    --glint-duration: 43s;
    top: 23px;
    left: 38%;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.48), rgba(255, 211, 124, 0.13) 54%, rgba(255, 255, 255, 0.28));
    filter: drop-shadow(0 0 7px rgba(255, 218, 142, 0.14));
    transform: rotate(8deg);
    animation: ChromaFlare__facetOneFloat___d3Kgq 42s -12s ease-in-out infinite alternate;
}

.ChromaFlare__facetTwo___Zul1L {
    --glint-delay: -7s;
    --glint-duration: 61s;
    right: 9%;
    bottom: 20px;
    width: 58px;
    height: 100px;
    background: linear-gradient(155deg, rgba(255, 255, 255, 0.4), rgba(244, 190, 88, 0.12) 48%, rgba(255, 255, 255, 0.24));
    filter: blur(0.65px) saturate(108%);
    transform: rotate(-17deg);
    animation: ChromaFlare__facetTwoFloat___vGo2W 48s -29s ease-in-out infinite alternate;
}

.ChromaFlare__facetThree___SgwaH {
    --glint-delay: -35s;
    --glint-duration: 49s;
    bottom: 34px;
    left: 22%;
    width: 45px;
    height: 82px;
    background: linear-gradient(125deg, rgba(255, 255, 255, 0.46), rgba(255, 201, 82, 0.13) 53%, rgba(255, 255, 255, 0.26));
    filter: blur(0.25px) saturate(115%);
    transform: rotate(23deg);
    animation: ChromaFlare__facetThreeFloat___kCNuY 44s -19s ease-in-out infinite alternate;
}

.ChromaFlare__fragment___prISd {
    z-index: 6;
    border-color: rgba(255, 255, 255, 0.62);
    background:
        linear-gradient(135deg, rgba(255, 255, 255, 0.42), rgba(255, 255, 255, 0.07) 44%, rgba(255, 220, 145, 0.17) 78%, rgba(255, 255, 255, 0.28)),
        rgba(255, 255, 255, 0.035);
    box-shadow:
        inset 1px 1px 2px rgba(255, 255, 255, 0.86),
        inset -2px -3px 7px rgba(201, 158, 76, 0.14),
        0 5px 12px rgba(26, 21, 24, 0.16);
    width: 31px;
    height: 51px;
    border-radius: 8px;
    clip-path: polygon(50% 0, 100% 49%, 50% 100%, 0 51%);
    backdrop-filter: none;
    opacity: 0.78;
    will-change: transform;
    animation: ChromaFlare__fragmentFloat___VG9tx 6.8s cubic-bezier(0.45, 0, 0.55, 1) infinite alternate;
}

.ChromaFlare__fragmentOne___XYtKh,
.ChromaFlare__fragmentSix___BczIj,
.ChromaFlare__fragmentEleven___P615k {
    --glint-delay: -17.3s;
    --glint-duration: 23.7s;
}

.ChromaFlare__fragmentTwo___WOMBt,
.ChromaFlare__fragmentSeven___lQDj0,
.ChromaFlare__fragmentTwelve___iVVPp {
    --glint-delay: -6.4s;
    --glint-duration: 31.9s;
}

.ChromaFlare__fragmentThree____E__T,
.ChromaFlare__fragmentEight___cWaJZ,
.ChromaFlare__fragmentThirteen___bSYQm {
    --glint-delay: -25.1s;
    --glint-duration: 37.3s;
}

.ChromaFlare__fragmentFour___YsW8t,
.ChromaFlare__fragmentNine___F_Z9n,
.ChromaFlare__fragmentFourteen___y_95V {
    --glint-delay: -9.8s;
    --glint-duration: 19.1s;
}

.ChromaFlare__fragmentFive___IcugK,
.ChromaFlare__fragmentTen___mC15Q {
    --glint-delay: -28.6s;
    --glint-duration: 41.7s;
}

.ChromaFlare__fragmentOne___XYtKh,
.ChromaFlare__fragmentEleven___P615k {
    filter: blur(0.8px);
    opacity: 0.58;
}

.ChromaFlare__fragmentThree____E__T,
.ChromaFlare__fragmentTwelve___iVVPp {
    filter: blur(0.35px);
}

.ChromaFlare__fragmentSeven___lQDj0,
.ChromaFlare__fragmentNine___F_Z9n {
    filter: drop-shadow(0 0 3px rgba(255, 224, 159, 0.22));
}

.ChromaFlare__fragmentOne___XYtKh {
    top: 29px;
    left: 20%;
    transform: rotate(-16deg);
}

.ChromaFlare__fragmentTwo___WOMBt {
    top: 24px;
    right: 20%;
    width: 25px;
    height: 42px;
    transform: rotate(24deg);
    animation-delay: -3s;
}

.ChromaFlare__fragmentThree____E__T {
    right: 30%;
    bottom: 29px;
    width: 21px;
    height: 36px;
    transform: rotate(-31deg);
    animation-delay: -6s;
}

.ChromaFlare__fragmentFour___YsW8t {
    top: 43%;
    left: 29%;
    width: 18px;
    height: 29px;
    transform: rotate(14deg);
    animation-delay: -1.4s;
    animation-duration: 5.7s;
}

.ChromaFlare__fragmentFive___IcugK {
    top: 34%;
    right: 31%;
    width: 16px;
    height: 27px;
    transform: rotate(-22deg);
    animation-delay: -3.7s;
    animation-duration: 7.4s;
}

.ChromaFlare__fragmentSix___BczIj {
    bottom: 28%;
    left: 39%;
    width: 22px;
    height: 34px;
    transform: rotate(31deg);
    animation-delay: -5.2s;
    animation-duration: 6.1s;
}

.ChromaFlare__fragmentSeven___lQDj0 {
    top: 24%;
    left: 43%;
    width: 13px;
    height: 22px;
    transform: rotate(-8deg);
    animation-delay: -2.6s;
    animation-duration: 4.9s;
}

.ChromaFlare__fragmentEight___cWaJZ {
    right: 39%;
    bottom: 20%;
    width: 15px;
    height: 24px;
    transform: rotate(19deg);
    animation-delay: -4.4s;
    animation-duration: 8.1s;
}

.ChromaFlare__fragmentNine___F_Z9n {
    top: 17%;
    left: 31%;
    width: 12px;
    height: 20px;
    transform: rotate(37deg);
    animation-delay: -7.1s;
    animation-duration: 6.4s;
}

.ChromaFlare__fragmentTen___mC15Q {
    top: 51%;
    right: 22%;
    width: 14px;
    height: 23px;
    transform: rotate(-39deg);
    animation-delay: -2.1s;
    animation-duration: 7.8s;
}

.ChromaFlare__fragmentEleven___P615k {
    right: 16%;
    bottom: 35%;
    width: 11px;
    height: 18px;
    transform: rotate(28deg);
    animation-delay: -8.2s;
    animation-duration: 9.2s;
}

.ChromaFlare__fragmentTwelve___iVVPp {
    bottom: 12%;
    left: 48%;
    width: 17px;
    height: 26px;
    transform: rotate(-14deg);
    animation-delay: -5.8s;
    animation-duration: 6.9s;
}

.ChromaFlare__fragmentThirteen___bSYQm {
    top: 58%;
    left: 16%;
    width: 13px;
    height: 21px;
    transform: rotate(11deg);
    animation-delay: -4.8s;
    animation-duration: 8.6s;
}

.ChromaFlare__fragmentFourteen___y_95V {
    top: 15%;
    right: 34%;
    width: 10px;
    height: 17px;
    transform: rotate(-27deg);
    animation-delay: -9.3s;
    animation-duration: 5.9s;
}

.ChromaFlare__fragmentFifteen___iFx1K {
    top: 31%;
    left: 7%;
    width: 13px;
    height: 21px;
    opacity: 0.54;
    filter: blur(0.45px);
    transform: rotate(19deg);
    animation-delay: -2.9s;
    animation-duration: 7.2s;
}

.ChromaFlare__fragmentSixteen___YmoVi {
    top: 28%;
    right: 8%;
    width: 11px;
    height: 18px;
    opacity: 0.5;
    filter: blur(0.55px);
    transform: rotate(-13deg);
    animation-delay: -4.6s;
    animation-duration: 8.4s;
}

.ChromaFlare__fragmentSeventeen____3hpK {
    top: 55%;
    left: 11%;
    width: 9px;
    height: 15px;
    opacity: 0.48;
    transform: rotate(-32deg);
    animation-delay: -1.8s;
    animation-duration: 6.6s;
}

.ChromaFlare__fragmentEighteen___T8vlP {
    top: 62%;
    right: 12%;
    width: 12px;
    height: 20px;
    opacity: 0.52;
    filter: blur(0.35px);
    transform: rotate(27deg);
    animation-delay: -5.5s;
    animation-duration: 7.9s;
}

.ChromaFlare__fragmentNineteen___PA7Op {
    top: 74%;
    left: 29%;
    width: 8px;
    height: 13px;
    opacity: 0.44;
    filter: blur(0.3px);
    transform: rotate(11deg);
    animation-delay: -3.8s;
    animation-duration: 9.1s;
}

.ChromaFlare__fragmentTwenty___cCUux {
    top: 18%;
    right: 28%;
    width: 9px;
    height: 15px;
    opacity: 0.48;
    filter: blur(0.25px);
    transform: rotate(-21deg);
    animation-delay: -6.2s;
    animation-duration: 6.1s;
}

.ChromaFlare__dust___xBGxf {
    position: absolute;
    z-index: 7;
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background: rgba(255, 246, 204, 0.72);
    box-shadow: 0 0 5px 1px rgba(255, 218, 125, 0.38);
    filter: blur(0.2px);
    mix-blend-mode: screen;
    opacity: 0;
    pointer-events: none;
    animation: ChromaFlare__dustDrift___jv3qX 12s ease-in-out infinite;
}

.ChromaFlare__dustOne___gWH4m {
    top: 29%;
    left: 34%;
    width: 3px;
    height: 3px;
    animation-delay: -1.2s;
    animation-duration: 13.5s;
}

.ChromaFlare__dustTwo___hyMKX {
    top: 39%;
    left: 43%;
    animation-delay: -6.8s;
    animation-duration: 10.5s;
}

.ChromaFlare__dustThree___XBFMO {
    top: 53%;
    left: 28%;
    width: 1px;
    height: 1px;
    animation-delay: -3.6s;
    animation-duration: 15.5s;
}

.ChromaFlare__dustFour___R9_vN {
    top: 23%;
    left: 52%;
    width: 3px;
    height: 3px;
    animation-delay: -8.4s;
    animation-duration: 14.5s;
}

.ChromaFlare__dustFive___pTA9o {
    top: 45%;
    left: 59%;
    animation-delay: -2.7s;
    animation-duration: 11.5s;
}

.ChromaFlare__dustSix___mcSiy {
    top: 61%;
    left: 48%;
    width: 1px;
    height: 1px;
    animation-delay: -9.6s;
    animation-duration: 16.5s;
}

.ChromaFlare__dustSeven___ZluEP {
    top: 34%;
    left: 67%;
    width: 3px;
    height: 3px;
    animation-delay: -5.1s;
    animation-duration: 13s;
}

.ChromaFlare__dustEight___wn97F {
    top: 66%;
    left: 37%;
    animation-delay: -10.2s;
    animation-duration: 17s;
}

.ChromaFlare__dustNine___ZxevJ {
    top: 18%;
    left: 42%;
    width: 1px;
    height: 1px;
    animation-delay: -4.3s;
    animation-duration: 12.5s;
}

.ChromaFlare__dustTen___EXh0q {
    top: 72%;
    left: 56%;
    width: 3px;
    height: 3px;
    animation-delay: -7.4s;
    animation-duration: 15s;
}

.ChromaFlare__dustEleven___uZ5oC {
    top: 48%;
    left: 73%;
    width: 1px;
    height: 1px;
    animation-delay: -11.5s;
    animation-duration: 18s;
}

.ChromaFlare__dustTwelve___YZBxF {
    top: 57%;
    left: 65%;
    width: 3px;
    height: 3px;
    animation-delay: -13.2s;
    animation-duration: 14s;
}

.ChromaFlare__microDust___Sx6FA {
    width: 1px;
    height: 1px;
    box-shadow: 0 0 3px rgba(255, 218, 125, 0.3);
    animation-name: ChromaFlare__microDustDrift___x1U6Q;
}

.ChromaFlare__dustThirteen___QKORq {
    top: 26%;
    left: 24%;
    animation-delay: -2.4s;
    animation-duration: 11.2s;
}

.ChromaFlare__dustFourteen___UyuZn {
    top: 31%;
    left: 47%;
    animation-delay: -8.1s;
    animation-duration: 14.8s;
}

.ChromaFlare__dustFifteen___e1vhc {
    top: 37%;
    left: 62%;
    animation-delay: -5.6s;
    animation-duration: 12.4s;
}

.ChromaFlare__dustSixteen___a0V4Z {
    top: 43%;
    left: 21%;
    animation-delay: -10.7s;
    animation-duration: 16.2s;
}

.ChromaFlare__dustSeventeen___leFTk {
    top: 49%;
    left: 39%;
    animation-delay: -1.7s;
    animation-duration: 13.6s;
}

.ChromaFlare__dustEighteen____zTlW {
    top: 55%;
    left: 54%;
    animation-delay: -7.3s;
    animation-duration: 10.8s;
}

.ChromaFlare__dustNineteen___c62xw {
    top: 63%;
    left: 71%;
    animation-delay: -12.2s;
    animation-duration: 17.4s;
}

.ChromaFlare__dustTwenty___oe2UG {
    top: 68%;
    left: 30%;
    animation-delay: -4.6s;
    animation-duration: 15.2s;
}

.ChromaFlare__dustTwentyOne___lNvcV {
    top: 74%;
    left: 45%;
    animation-delay: -9.4s;
    animation-duration: 12.8s;
}

.ChromaFlare__dustTwentyTwo___bcnLL {
    top: 22%;
    left: 69%;
    animation-delay: -6.2s;
    animation-duration: 18.2s;
}

.ChromaFlare__dustTwentyThree___Wwirz {
    top: 40%;
    left: 77%;
    animation-delay: -3.1s;
    animation-duration: 14.2s;
}

.ChromaFlare__dustTwentyFour___SiNPE {
    top: 58%;
    left: 12%;
    animation-delay: -11.1s;
    animation-duration: 16.8s;
}

.ChromaFlare__caustic___F9ZZL {
    position: absolute;
    z-index: 5;
    right: 6%;
    bottom: 14px;
    left: 6%;
    height: 39px;
    border-radius: 50%;
    background: linear-gradient(90deg, transparent 4%, rgba(255, 74, 51, 0.27) 28%, rgba(255, 211, 74, 0.48) 42%, rgba(255, 255, 255, 0.72) 49%, rgba(91, 218, 255, 0.42) 58%, rgba(169, 91, 255, 0.24) 70%, transparent 96%);
    filter: blur(6px);
    mix-blend-mode: screen;
    opacity: 0.32;
    transform: rotate(-4deg);
    animation: ChromaFlare__causticPulse___xnwEG 26s cubic-bezier(0.42, 0, 0.24, 1) infinite;
}

.ChromaFlare__caustic___F9ZZL::after {
    position: absolute;
    inset: 12px 14% 7px;
    background: linear-gradient(90deg, transparent, rgba(255, 77, 48, 0.5), rgba(255, 219, 91, 0.55), rgba(93, 217, 255, 0.48), rgba(184, 91, 255, 0.42), transparent);
    content: "";
    filter: blur(2px);
    opacity: 0.48;
    transform: translateX(8px);
}

.ChromaFlare__lightWash___W0gM4 {
    position: absolute;
    z-index: 7;
    top: 18%;
    left: 45%;
    width: 350px;
    height: 320px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.6) 0 3%, rgba(255, 244, 218, 0.27) 12%, rgba(255, 209, 126, 0.075) 33%, transparent 68%);
    mix-blend-mode: screen;
    pointer-events: none;
    transform: translate(-50%, -50%);
    animation: ChromaFlare__washTravel___CNu0q 70s cubic-bezier(0.45, 0, 0.3, 1) infinite;
}

.ChromaFlare__flare___J4roP {
    position: absolute;
    z-index: 10;
    top: 47%;
    left: 50%;
    width: 0;
    height: 0;
    pointer-events: none;
    transform: translate(-50%, -50%);
    animation: ChromaFlare__sourceTravel___pfjPx 70s cubic-bezier(0.45, 0, 0.3, 1) infinite;
}

.ChromaFlare__halo___Yi1vl {
    position: absolute;
    width: 155px;
    height: 155px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.94) 0 3%, rgba(255, 248, 224, 0.46) 9%, rgba(255, 220, 155, 0.11) 26%, transparent 69%);
    filter: blur(2px);
    mix-blend-mode: screen;
    transform: translate(-50%, -50%);
    animation: ChromaFlare__haloPulse___I1_oI 21s cubic-bezier(0.45, 0, 0.25, 1) infinite;
}

.ChromaFlare__core___cS9ur {
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ffffff;
    box-shadow:
        0 0 4px 2px #ffffff,
        0 0 14px 7px rgba(255, 255, 255, 0.96),
        0 0 30px 15px rgba(255, 218, 117, 0.78),
        0 0 68px 30px rgba(255, 166, 37, 0.34);
    transform: translate(-50%, -50%);
    animation: ChromaFlare__coreFlash___IJaiy 24.7s cubic-bezier(0.38, 0, 0.22, 1) infinite;
}

.ChromaFlare__horizontalStreak___tmBrb {
    position: absolute;
    width: 286px;
    height: 4px;
    border-radius: 50%;
    background: linear-gradient(90deg, transparent, rgba(255, 73, 45, 0.2) 17%, rgba(255, 211, 82, 0.3) 34%, rgba(255, 255, 255, 0.96) 49%, rgba(92, 219, 255, 0.3) 63%, rgba(179, 83, 255, 0.2) 79%, transparent);
    box-shadow:
        0 -2px 9px rgba(98, 211, 255, 0.28),
        0 2px 8px rgba(255, 96, 58, 0.28);
    filter: blur(0.7px);
    mix-blend-mode: screen;
    transform: translate(-50%, -50%);
    animation: ChromaFlare__streakPulse___UsY5K 28.5s cubic-bezier(0.45, 0, 0.25, 1) infinite;
}

.ChromaFlare__ray___TFdxZ {
    position: absolute;
    width: 220px;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(255, 239, 185, 0.15) 25%, rgba(255, 255, 255, 0.9) 50%, rgba(255, 224, 139, 0.14) 75%, transparent);
    filter: blur(0.45px);
    mix-blend-mode: screen;
    transform-origin: center;
    animation: ChromaFlare__rayFlash____DwLE 31s cubic-bezier(0.4, 0, 0.24, 1) infinite;
}

.ChromaFlare__rayVertical___jOYop {
    transform: translate(-50%, -50%) rotate(90deg);
}

.ChromaFlare__rayDiagonalOne___PGSCz {
    width: 175px;
    box-shadow:
        0 -1px 5px rgba(91, 214, 255, 0.2),
        0 1px 5px rgba(255, 91, 98, 0.2);
    transform: translate(-50%, -50%) rotate(40deg);
    animation-delay: -3.1s;
}

.ChromaFlare__rayDiagonalTwo___SFlyd {
    width: 165px;
    opacity: 0.72;
    transform: translate(-50%, -50%) rotate(-47deg);
    animation-delay: -7.4s;
}

.ChromaFlare__lensGhost___eR0tk {
    position: absolute;
    z-index: 8;
    border: 1px solid rgba(255, 211, 112, 0.34);
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.14), rgba(255, 196, 68, 0.12) 45%, transparent 72%);
    filter: blur(1.2px);
    mix-blend-mode: screen;
    pointer-events: none;
    animation: ChromaFlare__ghostDrift___bi1DC 7s ease-in-out infinite alternate;
}

.ChromaFlare__ghostOne___UOvyb {
    top: 19%;
    right: 16%;
    width: 31px;
    height: 31px;
    opacity: 0.88;
}

.ChromaFlare__ghostTwo___lnpSp {
    bottom: 17%;
    left: 25%;
    width: 54px;
    height: 54px;
    border-color: rgba(255, 190, 65, 0.32);
    opacity: 0.8;
    animation-delay: -2s;
}

.ChromaFlare__ghostThree___lFbEi {
    top: 12%;
    right: 7%;
    width: 15px;
    height: 15px;
    background: rgba(255, 227, 139, 0.52);
    opacity: 0.88;
    animation-delay: -3.5s;
}

.ChromaFlare__replayButton___HnSKS,
.ChromaFlare__fullscreenButton___Y7Jc5 {
    padding: 5px 11px;
    color: rgba(255, 247, 225, 0.98);
    background: rgba(54, 43, 37, 0.88);
    border: 1px solid rgba(255, 220, 153, 0.7);
    border-radius: 4px;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.18),
        0 2px 8px rgba(28, 19, 18, 0.32);
    cursor: pointer;
    font: inherit;
    font-size: 12px;
    text-shadow: 0 1px 2px rgba(20, 13, 12, 0.72);
}

.ChromaFlare__actions___aAW_O {
    display: flex;
    gap: 8px;
    justify-content: center;
}

.ChromaFlare__replayButton___HnSKS:hover,
.ChromaFlare__replayButton___HnSKS:focus-visible,
.ChromaFlare__fullscreenButton___Y7Jc5:hover,
.ChromaFlare__fullscreenButton___Y7Jc5:focus-visible {
    color: rgba(48, 31, 17, 1);
    background: rgba(255, 225, 158, 0.96);
    border-color: rgba(255, 247, 214, 0.98);
    outline: none;
    text-shadow: none;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.7),
        0 0 12px rgba(255, 197, 82, 0.48);
}

.ChromaFlare__demo___rEDbA:fullscreen {
    position: relative;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    gap: 0;
    width: 100vw;
    height: 100vh;
    min-height: 100vh;
    overflow: hidden;
    padding: 0;
    background:
        radial-gradient(circle at 50% 46%, rgba(255, 177, 61, 0.24), transparent 31%),
        radial-gradient(ellipse at 13% 57%, rgba(161, 143, 127, 0.18), transparent 38%),
        radial-gradient(ellipse at 89% 41%, rgba(112, 124, 139, 0.16), transparent 39%),
        linear-gradient(135deg, #514f4e 0%, #786c62 47%, #575451 100%);
}

.ChromaFlare__demo___rEDbA:fullscreen .ChromaFlare__scene___eHTIT {
    flex: 0 0 auto;
    width: 500px;
    height: 270px;
    overflow: visible;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    transform: scale(var(--chroma-fullscreen-scale, 1));
    transform-origin: center;
}

.ChromaFlare__demo___rEDbA:fullscreen .ChromaFlare__scene___eHTIT::before {
    display: none;
}

.ChromaFlare__demo___rEDbA:fullscreen .ChromaFlare__actions___aAW_O {
    display: none;
}

@keyframes ChromaFlare__daylightDrift___vLTjC {
    from {
        transform: translate3d(-2%, -2%, 0) scale(0.98);
        opacity: 0.72;
    }

    to {
        transform: translate3d(4%, 3%, 0) scale(1.05);
        opacity: 1;
    }
}

@keyframes ChromaFlare__internalRefraction___SD8OJ {
    0%,
    34%,
    100% {
        transform: translateX(-58%) rotate(-4deg);
        opacity: 0.025;
    }

    39% {
        transform: translateX(-38%) rotate(-2deg);
        opacity: 0.08;
    }

    42.5% {
        transform: translateX(-3%) rotate(0deg);
        opacity: 0.96;
    }

    46% {
        transform: translateX(38%) rotate(2deg);
        opacity: 0.12;
    }

    51%,
    94% {
        transform: translateX(68%) rotate(3deg);
        opacity: 0.025;
    }
}

@keyframes ChromaFlare__spectralEdge___OREU_ {
    0%,
    38%,
    47%,
    100% {
        opacity: 0.035;
        filter: blur(0.45px) saturate(92%);
    }

    41% {
        opacity: 0.16;
        filter: blur(0.25px) saturate(115%);
    }

    42.5% {
        opacity: 0.94;
        filter: blur(0.1px) saturate(155%);
    }

    44% {
        opacity: 0.18;
        filter: blur(0.3px) saturate(110%);
    }
}

@keyframes ChromaFlare__facetChroma___cK3tD {
    0%,
    34%,
    100% {
        opacity: 0.28;
        transform: translateX(-4%);
    }

    43% {
        opacity: 0.78;
        transform: translateX(0);
    }

    49% {
        opacity: 0.94;
        transform: translateX(4%);
    }

    57%,
    84% {
        opacity: 0.36;
        transform: translateX(1%);
    }
}

@keyframes ChromaFlare__ambientFloat___sEjEH {
    from {
        transform: translate3d(-10px, 4px, 0) scale(0.94);
    }

    to {
        transform: translate3d(14px, -8px, 0) scale(1.08);
    }
}

@keyframes ChromaFlare__planeBackFloat____2WJw {
    from {
        transform: translate3d(-2px, 1px, 0) rotate(-5.4deg) scale(0.995);
    }

    to {
        transform: translate3d(3px, -2px, 0) rotate(-4.5deg) scale(1.006);
    }
}

@keyframes ChromaFlare__planeLeftFloat___GaeFM {
    from {
        transform: translate3d(-3px, 2px, 0) rotate(-14deg);
    }

    to {
        transform: translate3d(4px, -3px, 0) rotate(-10deg);
    }
}

@keyframes ChromaFlare__planeRightFloat___uN44O {
    from {
        transform: translate3d(3px, -2px, 0) rotate(12deg);
    }

    to {
        transform: translate3d(-3px, 3px, 0) rotate(15deg);
    }
}

@keyframes ChromaFlare__facetOneFloat___d3Kgq {
    from {
        transform: translate3d(-2px, 2px, 0) rotate(7deg);
    }

    to {
        transform: translate3d(3px, -3px, 0) rotate(9.5deg);
    }
}

@keyframes ChromaFlare__facetTwoFloat___vGo2W {
    from {
        transform: translate3d(3px, -2px, 0) rotate(-18deg);
    }

    to {
        transform: translate3d(-3px, 3px, 0) rotate(-16deg);
    }
}

@keyframes ChromaFlare__facetThreeFloat___kCNuY {
    from {
        transform: translate3d(-2px, 3px, 0) rotate(22deg);
    }

    to {
        transform: translate3d(3px, -2px, 0) rotate(24.5deg);
    }
}

@keyframes ChromaFlare__edgePrismFloat___kN_Gd {
    from {
        transform: translate3d(var(--edge-start-x), 4px, 0) rotate(var(--edge-start-rotation)) scale(0.98);
    }

    to {
        transform: translate3d(var(--edge-end-x), -4px, 0) rotate(var(--edge-end-rotation)) scale(1.03);
    }
}

@keyframes ChromaFlare__edgeGlassGlint___Mx825 {
    0%,
    100% {
        opacity: 0.18;
        transform: translateX(-22%);
    }

    40% {
        opacity: 0.42;
        transform: translateX(2%);
    }

    47% {
        opacity: 0.68;
        transform: translateX(9%);
    }

    55% {
        opacity: 0.28;
        transform: translateX(19%);
    }

    78% {
        opacity: 0.34;
        transform: translateX(5%);
    }
}

@keyframes ChromaFlare__edgeSeamDrift___O9Onc {
    from {
        transform: translate3d(-2px, 0, 0) rotate(var(--seam-angle));
        opacity: 0.16;
    }

    to {
        transform: translate3d(3px, 2px, 0) rotate(calc(var(--seam-angle) + 2deg));
        opacity: 0.3;
    }
}

@keyframes ChromaFlare__fragmentFloat___VG9tx {
    0% {
        translate: -13px 10px;
        rotate: -7deg;
        scale: 0.94 1.02;
    }

    47% {
        translate: 1px -2px;
        rotate: 3deg;
        scale: 1.03 0.96;
    }

    100% {
        translate: 12px -15px;
        rotate: 10deg;
        scale: 0.97 1.04;
    }
}

@keyframes ChromaFlare__dustDrift___jv3qX {
    0%,
    100% {
        opacity: 0.05;
        transform: translate3d(-4px, -8px, 0) scale(0.72);
    }

    28% {
        opacity: 0.48;
        transform: translate3d(5px, 2px, 0) scale(1.08);
    }

    62% {
        opacity: 0.24;
        transform: translate3d(-3px, 13px, 0) scale(0.86);
    }

    82% {
        opacity: 0.58;
        transform: translate3d(8px, 7px, 0) scale(1);
    }
}

@keyframes ChromaFlare__microDustDrift___x1U6Q {
    0%,
    100% {
        opacity: 0.03;
        transform: translate3d(-3px, -6px, 0) scale(0.72);
    }

    31% {
        opacity: 0.3;
        transform: translate3d(4px, 3px, 0) scale(1);
    }

    64% {
        opacity: 0.14;
        transform: translate3d(-2px, 10px, 0) scale(0.82);
    }

    83% {
        opacity: 0.4;
        transform: translate3d(6px, 5px, 0) scale(0.96);
    }
}

@keyframes ChromaFlare__causticPulse___xnwEG {
    0%,
    39%,
    100% {
        opacity: 0.22;
        transform: rotate(-4deg) scaleX(0.8);
    }

    46% {
        opacity: 0.34;
        transform: rotate(-3.5deg) scaleX(0.9);
    }

    50% {
        opacity: 0.82;
        transform: rotate(-4deg) scaleX(1.08);
    }

    55% {
        opacity: 0.27;
        transform: rotate(-4.5deg) scaleX(0.86);
    }

    79% {
        opacity: 0.38;
        transform: rotate(-3.8deg) scaleX(0.92);
    }
}

@keyframes ChromaFlare__washTravel___CNu0q {
    0%,
    8% {
        transform: translate(-50%, -50%) translate3d(-18px, -8px, 0) scale(0.9);
        opacity: 0.44;
    }

    26% {
        transform: translate(-50%, -50%) translate3d(0, 0, 0) scale(1.04);
        opacity: 0.9;
    }

    43% {
        transform: translate(-50%, -50%) translate3d(42px, 18px, 0) scale(0.78);
        opacity: 0.58;
    }

    61% {
        transform: translate(-50%, -50%) translate3d(17px, -21px, 0) scale(1.12);
        opacity: 0.96;
    }

    78%,
    100% {
        transform: translate(-50%, -50%) translate3d(-18px, -8px, 0) scale(0.9);
        opacity: 0.44;
    }
}

@keyframes ChromaFlare__sourceTravel___pfjPx {
    0%,
    8% {
        transform: translate(-50%, -50%) translate3d(-18px, -8px, 0) scale(0.82);
    }

    26% {
        transform: translate(-50%, -50%) translate3d(0, 0, 0) scale(1.04);
    }

    43% {
        transform: translate(-50%, -50%) translate3d(43px, 18px, 0) scale(0.74);
    }

    61% {
        transform: translate(-50%, -50%) translate3d(18px, -21px, 0) scale(1.13);
    }

    78%,
    100% {
        transform: translate(-50%, -50%) translate3d(-18px, -8px, 0) scale(0.82);
    }
}

@keyframes ChromaFlare__haloPulse___I1_oI {
    0%,
    100% {
        opacity: 0.52;
        transform: translate(-50%, -50%) scale(0.88);
    }

    24% {
        opacity: 0.56;
        transform: translate(-50%, -50%) scale(0.91);
    }

    47% {
        opacity: 0.84;
        transform: translate(-50%, -50%) scale(1.05);
    }

    53% {
        opacity: 0.64;
        transform: translate(-50%, -50%) scale(0.96);
    }

    77% {
        opacity: 0.55;
        transform: translate(-50%, -50%) scale(0.9);
    }

    86% {
        opacity: 0.7;
        transform: translate(-50%, -50%) scale(0.99);
    }
}

@keyframes ChromaFlare__coreFlash___IJaiy {
    0%,
    34%,
    100% {
        transform: translate(-50%, -50%) scale(0.86);
        opacity: 0.78;
    }

    43% {
        transform: translate(-50%, -50%) scale(0.96);
        opacity: 0.9;
    }

    48% {
        transform: translate(-50%, -50%) scale(1.12);
        opacity: 1;
    }

    52% {
        transform: translate(-50%, -50%) scale(0.93);
        opacity: 0.84;
    }

    75% {
        transform: translate(-50%, -50%) scale(0.86);
        opacity: 0.78;
    }

    79% {
        transform: translate(-50%, -50%) scale(1.3);
        opacity: 1;
    }

    83% {
        transform: translate(-50%, -50%) scale(0.98);
        opacity: 0.88;
    }
}

@keyframes ChromaFlare__rayFlash____DwLE {
    0%,
    38%,
    100% {
        opacity: 0.18;
    }

    47% {
        opacity: 0.72;
    }

    52% {
        opacity: 0.24;
    }

    72% {
        opacity: 0.9;
    }

    78% {
        opacity: 0.2;
    }
}

@keyframes ChromaFlare__streakPulse___UsY5K {
    0%,
    100% {
        opacity: 0.2;
        transform: translate(-50%, -50%) scaleX(0.72);
    }

    45% {
        opacity: 0.28;
        transform: translate(-50%, -50%) scaleX(0.8);
    }

    51% {
        opacity: 0.92;
        transform: translate(-50%, -50%) scaleX(1.08);
    }

    56% {
        opacity: 0.22;
        transform: translate(-50%, -50%) scaleX(0.74);
    }

    79% {
        opacity: 0.45;
        transform: translate(-50%, -50%) scaleX(0.9);
    }
}

@keyframes ChromaFlare__ghostDrift___bi1DC {
    from {
        opacity: 0.22;
        transform: translate3d(-3px, 2px, 0) scale(0.9);
    }

    to {
        opacity: 0.62;
        transform: translate3d(5px, -4px, 0) scale(1.08);
    }
}

@media (prefers-reduced-motion: reduce) {
    .ChromaFlare__scene___eHTIT::before,
    .ChromaFlare__ambient___vspU2,
    .ChromaFlare__glassPlane___xl89E,
    .ChromaFlare__glassPlane___xl89E::before,
    .ChromaFlare__glassFacet___prsEl,
    .ChromaFlare__glassFacet___prsEl::before,
    .ChromaFlare__edgePrism___lOQ3v,
    .ChromaFlare__edgeSeam___DU14Z,
    .ChromaFlare__fragment___prISd,
    .ChromaFlare__fragment___prISd::before,
    .ChromaFlare__fragment___prISd::after,
    .ChromaFlare__dust___xBGxf,
    .ChromaFlare__caustic___F9ZZL,
    .ChromaFlare__lightWash___W0gM4,
    .ChromaFlare__flare___J4roP,
    .ChromaFlare__halo___Yi1vl,
    .ChromaFlare__core___cS9ur,
    .ChromaFlare__horizontalStreak___tmBrb,
    .ChromaFlare__lensGhost___eR0tk {
        animation-duration: 18s;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"demo": `ChromaFlare__demo___rEDbA`,
	"scene": `ChromaFlare__scene___eHTIT`,
	"daylightDrift": `ChromaFlare__daylightDrift___vLTjC`,
	"ambient": `ChromaFlare__ambient___vspU2`,
	"ambientFloat": `ChromaFlare__ambientFloat___sEjEH`,
	"ambientGold": `ChromaFlare__ambientGold___XicCQ`,
	"ambientWhite": `ChromaFlare__ambientWhite___Zt6Bk`,
	"glassPlane": `ChromaFlare__glassPlane___xl89E`,
	"glassFacet": `ChromaFlare__glassFacet___prsEl`,
	"fragment": `ChromaFlare__fragment___prISd`,
	"spectralEdge": `ChromaFlare__spectralEdge___OREU_`,
	"internalRefraction": `ChromaFlare__internalRefraction___SD8OJ`,
	"planeBack": `ChromaFlare__planeBack___eu2rz`,
	"planeBackFloat": `ChromaFlare__planeBackFloat____2WJw`,
	"planeLeft": `ChromaFlare__planeLeft___jDrdr`,
	"planeLeftFloat": `ChromaFlare__planeLeftFloat___GaeFM`,
	"planeRight": `ChromaFlare__planeRight___tlvov`,
	"planeRightFloat": `ChromaFlare__planeRightFloat___uN44O`,
	"edgePrism": `ChromaFlare__edgePrism___lOQ3v`,
	"edgePrismFloat": `ChromaFlare__edgePrismFloat___kN_Gd`,
	"edgeGlassGlint": `ChromaFlare__edgeGlassGlint___Mx825`,
	"edgePrismLeft": `ChromaFlare__edgePrismLeft___f2v20`,
	"edgePrismRight": `ChromaFlare__edgePrismRight___ZGp85`,
	"edgeSeam": `ChromaFlare__edgeSeam___DU14Z`,
	"edgeSeamDrift": `ChromaFlare__edgeSeamDrift___O9Onc`,
	"edgeSeamLeft": `ChromaFlare__edgeSeamLeft___Vui7z`,
	"edgeSeamRight": `ChromaFlare__edgeSeamRight___WYchq`,
	"facetChroma": `ChromaFlare__facetChroma___cK3tD`,
	"facetOne": `ChromaFlare__facetOne___Ww8G3`,
	"facetOneFloat": `ChromaFlare__facetOneFloat___d3Kgq`,
	"facetTwo": `ChromaFlare__facetTwo___Zul1L`,
	"facetTwoFloat": `ChromaFlare__facetTwoFloat___vGo2W`,
	"facetThree": `ChromaFlare__facetThree___SgwaH`,
	"facetThreeFloat": `ChromaFlare__facetThreeFloat___kCNuY`,
	"fragmentFloat": `ChromaFlare__fragmentFloat___VG9tx`,
	"fragmentOne": `ChromaFlare__fragmentOne___XYtKh`,
	"fragmentSix": `ChromaFlare__fragmentSix___BczIj`,
	"fragmentEleven": `ChromaFlare__fragmentEleven___P615k`,
	"fragmentTwo": `ChromaFlare__fragmentTwo___WOMBt`,
	"fragmentSeven": `ChromaFlare__fragmentSeven___lQDj0`,
	"fragmentTwelve": `ChromaFlare__fragmentTwelve___iVVPp`,
	"fragmentThree": `ChromaFlare__fragmentThree____E__T`,
	"fragmentEight": `ChromaFlare__fragmentEight___cWaJZ`,
	"fragmentThirteen": `ChromaFlare__fragmentThirteen___bSYQm`,
	"fragmentFour": `ChromaFlare__fragmentFour___YsW8t`,
	"fragmentNine": `ChromaFlare__fragmentNine___F_Z9n`,
	"fragmentFourteen": `ChromaFlare__fragmentFourteen___y_95V`,
	"fragmentFive": `ChromaFlare__fragmentFive___IcugK`,
	"fragmentTen": `ChromaFlare__fragmentTen___mC15Q`,
	"fragmentFifteen": `ChromaFlare__fragmentFifteen___iFx1K`,
	"fragmentSixteen": `ChromaFlare__fragmentSixteen___YmoVi`,
	"fragmentSeventeen": `ChromaFlare__fragmentSeventeen____3hpK`,
	"fragmentEighteen": `ChromaFlare__fragmentEighteen___T8vlP`,
	"fragmentNineteen": `ChromaFlare__fragmentNineteen___PA7Op`,
	"fragmentTwenty": `ChromaFlare__fragmentTwenty___cCUux`,
	"dust": `ChromaFlare__dust___xBGxf`,
	"dustDrift": `ChromaFlare__dustDrift___jv3qX`,
	"dustOne": `ChromaFlare__dustOne___gWH4m`,
	"dustTwo": `ChromaFlare__dustTwo___hyMKX`,
	"dustThree": `ChromaFlare__dustThree___XBFMO`,
	"dustFour": `ChromaFlare__dustFour___R9_vN`,
	"dustFive": `ChromaFlare__dustFive___pTA9o`,
	"dustSix": `ChromaFlare__dustSix___mcSiy`,
	"dustSeven": `ChromaFlare__dustSeven___ZluEP`,
	"dustEight": `ChromaFlare__dustEight___wn97F`,
	"dustNine": `ChromaFlare__dustNine___ZxevJ`,
	"dustTen": `ChromaFlare__dustTen___EXh0q`,
	"dustEleven": `ChromaFlare__dustEleven___uZ5oC`,
	"dustTwelve": `ChromaFlare__dustTwelve___YZBxF`,
	"microDust": `ChromaFlare__microDust___Sx6FA`,
	"microDustDrift": `ChromaFlare__microDustDrift___x1U6Q`,
	"dustThirteen": `ChromaFlare__dustThirteen___QKORq`,
	"dustFourteen": `ChromaFlare__dustFourteen___UyuZn`,
	"dustFifteen": `ChromaFlare__dustFifteen___e1vhc`,
	"dustSixteen": `ChromaFlare__dustSixteen___a0V4Z`,
	"dustSeventeen": `ChromaFlare__dustSeventeen___leFTk`,
	"dustEighteen": `ChromaFlare__dustEighteen____zTlW`,
	"dustNineteen": `ChromaFlare__dustNineteen___c62xw`,
	"dustTwenty": `ChromaFlare__dustTwenty___oe2UG`,
	"dustTwentyOne": `ChromaFlare__dustTwentyOne___lNvcV`,
	"dustTwentyTwo": `ChromaFlare__dustTwentyTwo___bcnLL`,
	"dustTwentyThree": `ChromaFlare__dustTwentyThree___Wwirz`,
	"dustTwentyFour": `ChromaFlare__dustTwentyFour___SiNPE`,
	"caustic": `ChromaFlare__caustic___F9ZZL`,
	"causticPulse": `ChromaFlare__causticPulse___xnwEG`,
	"lightWash": `ChromaFlare__lightWash___W0gM4`,
	"washTravel": `ChromaFlare__washTravel___CNu0q`,
	"flare": `ChromaFlare__flare___J4roP`,
	"sourceTravel": `ChromaFlare__sourceTravel___pfjPx`,
	"halo": `ChromaFlare__halo___Yi1vl`,
	"haloPulse": `ChromaFlare__haloPulse___I1_oI`,
	"core": `ChromaFlare__core___cS9ur`,
	"coreFlash": `ChromaFlare__coreFlash___IJaiy`,
	"horizontalStreak": `ChromaFlare__horizontalStreak___tmBrb`,
	"streakPulse": `ChromaFlare__streakPulse___UsY5K`,
	"ray": `ChromaFlare__ray___TFdxZ`,
	"rayFlash": `ChromaFlare__rayFlash____DwLE`,
	"rayVertical": `ChromaFlare__rayVertical___jOYop`,
	"rayDiagonalOne": `ChromaFlare__rayDiagonalOne___PGSCz`,
	"rayDiagonalTwo": `ChromaFlare__rayDiagonalTwo___SFlyd`,
	"lensGhost": `ChromaFlare__lensGhost___eR0tk`,
	"ghostDrift": `ChromaFlare__ghostDrift___bi1DC`,
	"ghostOne": `ChromaFlare__ghostOne___UOvyb`,
	"ghostTwo": `ChromaFlare__ghostTwo___lnpSp`,
	"ghostThree": `ChromaFlare__ghostThree___lFbEi`,
	"replayButton": `ChromaFlare__replayButton___HnSKS`,
	"fullscreenButton": `ChromaFlare__fullscreenButton___Y7Jc5`,
	"actions": `ChromaFlare__actions___aAW_O`
};
module.exports = ___CSS_LOADER_EXPORT___;
